<template>
  <div></div>
</template>

<script>
import * as turf from "@turf/turf";

export default {
  name: "Curve2d",
  props: {
    map: {
      required: true // mapbox对象
    },
    color: {
      required: false,
      default: '#FFFFFF'
    },
    width: {
      required: false,
      default: 4
    },
    opacity: {
      required: false,
      default: 1
    },
    lineData: {
      required: true // 线数据列表，需要geoJson: FutureCollection<Future<Point>>
    },
    layerId: {
      required: true,
    }
  },
  methods: {
    initLayer() {
      this.map.addSource(this.layerId, {
        type: "geojson",
        data: this.lineData,
        // lineMetrics:true
      })

      this.map.addLayer({
        id: this.layerId,
        type: 'line',
        source: this.layerId,
        paint: {
          'line-color': this.color,
          'line-width': this.width,
          'line-opacity': this.opacity,
        }
      }, 'polygonLayer')


      this.mapFitBoundary(this.lineData)
    },
    removeLineLayer() {
      if (this.map.getLayer(this.layerId))
        this.map.removeLayer(this.layerId)
      if (this.map.getSource(this.layerId))
        this.map.removeSource(this.layerId)
    },
    mapFitBoundary(geo) {
      const bbox = turf.bbox(geo)
      this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], {
        linear: false,
        animate: true,
        padding: {top: 0, bottom: 0, left: 0, right: 0},
      })
    },
  },
  mounted() {
    this.initLayer()
  },
  destroyed() {
    this.removeLineLayer()
  }
}
</script>

<style scoped>

</style>
